import { statusOf, statusColor, statusText } from "@/lib/otStatus";

function Faceplate({ tag }) {
  const st = statusOf(tag);
  const color = statusColor[st];
  const isAnalog = tag.type === "analog";
  const pct = isAnalog ? Math.max(0, Math.min(100, ((tag.value - (tag.min ?? 0)) / ((tag.max ?? 100) - (tag.min ?? 0))) * 100)) : 0;
  const on = ["RUNNING", "OPEN", "TRIGGERED"].includes(tag.value);

  return (
    <div className="bg-popover border border-border/60 rounded-sm p-3" data-testid={`faceplate-${tag.tag_id}`}>
      <div className="flex items-center justify-between border-b border-border/40 pb-1.5 mb-2">
        <span className="font-mono text-[11px] font-semibold">{tag.tag_id}</span>
        {isAnalog ? (
          <span className="w-2 h-2 rounded-full" style={{ background: color }} />
        ) : (
          <span className="font-mono text-[9px] px-1.5 py-0.5 rounded-sm" style={{ background: (tag.value === "TRIGGERED" ? statusColor.critical : on ? statusColor.normal : statusColor.inactive) + "22", color: tag.value === "TRIGGERED" ? statusColor.critical : on ? statusColor.normal : statusColor.inactive }}>{tag.value}</span>
        )}
      </div>
      <div className="text-[10px] text-muted-foreground truncate mb-1">{tag.name}</div>
      {isAnalog ? (
        <>
          <div className={`font-mono text-2xl font-semibold ${statusText[st] || ""}`}>{tag.value}<span className="text-[10px] text-muted-foreground ml-1">{tag.unit}</span></div>
          <div className="h-1.5 bg-secondary rounded-full mt-2 overflow-hidden">
            <div className="h-full transition-all duration-500" style={{ width: `${pct}%`, background: color }} />
          </div>
          <div className="flex justify-between font-mono text-[9px] text-muted-foreground mt-1">
            <span>{tag.min}</span>
            {tag.hi != null && <span className="text-status-warning">HI {tag.hi}</span>}
            <span>{tag.max}</span>
          </div>
        </>
      ) : (
        <div className="font-mono text-2xl font-semibold" style={{ color: tag.value === "TRIGGERED" ? statusColor.critical : on ? statusColor.normal : statusColor.inactive }}>
          {tag.value}
        </div>
      )}
    </div>
  );
}

export default function DcsFaceplates({ tags }) {
  return (
    <div className="bg-card border border-border/60 rounded-md" data-testid="dcs-faceplates">
      <div className="px-3 py-2 border-b border-border/60 bg-popover"><span className="label-ot">DCS Control Faceplates</span></div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 p-3">
        {tags.map((t) => <Faceplate key={t.tag_id} tag={t} />)}
      </div>
    </div>
  );
}
